

/*
 * Date: 2025
 * Description: Cart row interaction
 * Author: Philippe Leroux @ skitsc
 */

//Modules
import { ReactElement } from "react"
import { Box, Grid, IconButton, Paper, Typography } from "@mui/material"
import { DeleteForever } from "@mui/icons-material"

//Interfaces
import { i_cart_row_props } from "../../interfaces/display.interfaces"
import { renderPrice, renderStock } from "../../utils/utility"

const CartRow = ( props : i_cart_row_props ) : ReactElement => {
    const renderDescription = (description: string | null | undefined): string => {
        if (!description || description.trim() === "") {
            return "No description";
        }

        // Normalize spacing and split into words
        const words = description.trim().split(/\s+/);

        // Determine which words to keep
        const displayedWords = words.length > 5 ? words.slice(0, 3) : words;

        // Join and format string
        const result = displayedWords.join(" ");
        return result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
    };
    return (
        <Paper sx={{ border : '1px solid gray' , marginBottom : 1 }}>
            <Grid container>
                <Grid size={5} p={0.5}>
                    <Box sx={{ maxWidth: 140, maxHeight: 140, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                        <Box component="img" sx={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain'}} src={props.prepath + props.part.path} />
                    </Box>
                </Grid>
                <Grid size={5.5}>
                    <Box p={0.5}>
                        <Typography sx={{ mt:1}}>{renderDescription(props.part.description)}</Typography>
                        <Typography sx={{textDecoration : 'underline' , mt:1}}>{props.part.sku}</Typography>
                        <Typography sx={{ mt:1}}>{ props.type === 'user' ? props.part.price + '$' : renderPrice(props.part) +'$'}</Typography>
                        <Typography sx={{ mt : 1}}>{ props.type === 'user' ? props.part.stock : renderStock(props.part) }</Typography>
                    </Box>
                </Grid>
                <Grid size={1.5} sx={{ alignContent : 'center'}}>
                    <IconButton onClick={() => props.callback(props.part)}>
                        <DeleteForever sx={{ color : 'red'}}/>
                    </IconButton>
                </Grid>
            </Grid>
        </Paper>
    )
}

export default CartRow
